//@flow
import React, {useMemo} from 'react';
import {Checkbox, makeStyles, TableCell, TableRow} from '@material-ui/core';
import {FIXED_VARIANT_TABLE_CELLS, VARIANT_TABLE_CELLS} from '../../constants';
import {useEnabledVariantContext} from '../../context/productVariant';
import type {ProductDetailVariant} from '../../../../entities';
import {useActiveCellsId} from '../../utils';
import {
  useSelectedProductsVariants,
  useToggleVariantSelection,
} from '../../utils/bulkEditOptions';
import {useAlert} from '../../../../elements/Alert/AlertContext';

const useStyles = makeStyles(theme => ({
  row: {
    '& > *': {
      borderBottom: 'unset',
    },
    '&[data-disabled=true]': {
      background: '#f4f4f699',
      opacity: 0.5,
      pointerEvents: 'none',
    },
  },
}));

type Props = {
  productId: string,
  variant: ProductDetailVariant,
  countProductSelected: number,
  limitedSelected: number,
};

export default function VariantRow({
  productId,
  variant,
  countProductSelected,
  limitedSelected,
}: Props) {
  const classes = useStyles();
  const activeCellsId = useActiveCellsId();
  const {showAlert} = useAlert();

  const [enabled] = useEnabledVariantContext();

  const toggleVariantSelected = useToggleVariantSelection();
  const selectedProductVariants = useSelectedProductsVariants();

  const checkedProductVariant = useMemo(() => {
    return selectedProductVariants.some(
      selectedVariant => selectedVariant.id === variant.id
    );
  }, [variant.id, selectedProductVariants]);

  return (
    <TableRow className={classes.row} data-disabled={!enabled}>
      <TableCell padding="checkbox">
        <Checkbox
          onChange={() => {
            if (
              selectedProductVariants.some(
                variantSelect => variantSelect.id === variant.id
              )
            ) {
              toggleVariantSelected(variant, productId);
              return;
            }

            if (
              selectedProductVariants.length + countProductSelected >=
              limitedSelected
            ) {
              showAlert(
                `Solo puedes seleccionar hasta ${limitedSelected} productos/variantes`,
                {severity: 'warning'}
              );
              return;
            }

            toggleVariantSelected(variant, productId);
          }}
          checked={checkedProductVariant}
          color="primary"
        />
      </TableCell>
      {VARIANT_TABLE_CELLS.filter(cell => {
        if (FIXED_VARIANT_TABLE_CELLS.includes(cell.id)) return true;
        return activeCellsId.includes(cell.id);
      }).map(({CellComponent, id}) => (
        <CellComponent key={id} />
      ))}
    </TableRow>
  );
}
